<nav mat-tab-nav-bar class="table-header-tabs">
  <a [active]="isActive('partner')" mat-tab-link routerLink="./partner" data-cy="element-category-partner-config-tab">Partner
    Configuration</a>
  <a [active]="isActive('category')" mat-tab-link routerLink="./category" data-cy="element-category-config-tab">Category
    Configuration</a>
</nav>
<router-outlet></router-outlet>
